import GenericAjaxService from './GenericAjaxService';
import {privateAPI} from './api';

export default class ThreeDSService extends GenericAjaxService {
    static get3dsStatus(id, opts){
        return super.getAPI(privateAPI, `3DS/getStatus/${id}`, opts);
    }
}